var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-dialog',{attrs:{"dialog":_vm.dialog},on:{"submit":_vm.submitForm}},[_c('v-file-input',{attrs:{"label":"Wybierz plik z dysku"},model:{value:(_vm.selectedFile),callback:function ($$v) {_vm.selectedFile=$$v},expression:"selectedFile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }